import { createSlice } from '@reduxjs/toolkit';
import { activeDirType, activeModeType, isLayoutType } from './customizer.type';

export interface CustomizerStateType {
  activeDir?: activeDirType;
  activeMode?: activeModeType;
  SidebarWidth?: number;
  MiniSidebarWidth?: number;
  TopbarHeight?: number;
  isCollapse?: boolean;
  isLayout?: isLayoutType;
  isSidebarHover?: boolean;
  isMobileSidebar?: boolean;
  isHorizontal?: boolean;
  isLanguage?: string;
  isCardShadow?: boolean;
  borderRadius?: number;
  isEditCampaignView?: boolean;
}

const initialState: CustomizerStateType = {
  activeDir: 'ltr',
  activeMode: 'light',
  SidebarWidth: 270,
  MiniSidebarWidth: 87,
  TopbarHeight: 70,
  isLayout: 'boxed',
  isCollapse: false,
  isSidebarHover: false,
  isMobileSidebar: false,
  isHorizontal: false,
  isLanguage: 'en',
  isCardShadow: true,
  borderRadius: 7,
  isEditCampaignView: false,
};

const customizerSlice = createSlice({
  name: 'customizer',
  initialState,
  reducers: {
    setDarkMode: (state: CustomizerStateType, action) => {
      state.activeMode = action.payload;
    },
    setDir: (state: CustomizerStateType, action) => {
      state.activeDir = action.payload;
    },
    setLanguage: (state: CustomizerStateType, action) => {
      state.isLanguage = action.payload;
    },
    setCardShadow: (state: CustomizerStateType, action) => {
      state.isCardShadow = action.payload;
    },
    toggleSidebar: (state) => {
      state.isCollapse = !state.isCollapse;
    },
    setCollapse: (state: CustomizerStateType, action) => {
      state.isCollapse = action.payload;
    },
    hoverSidebar: (state: CustomizerStateType, action) => {
      state.isSidebarHover = action.payload;
    },
    toggleMobileSidebar: (state) => {
      state.isMobileSidebar = !state.isMobileSidebar;
    },
    toggleLayout: (state: CustomizerStateType, action) => {
      state.isLayout = action.payload;
    },
    toggleEditCampaignView: (state: CustomizerStateType, action) => {
      state.isEditCampaignView = action.payload;
    },
    toggleHorizontal: (state: CustomizerStateType, action) => {
      state.isHorizontal = action.payload;
    },
    setBorderRadius: (state: CustomizerStateType, action) => {
      state.borderRadius = action.payload;
    },
  },
});

export const actions = {
  ...customizerSlice.actions,
};

export const { reducer } = customizerSlice;
